import { IOptionType } from 'interfaces/forms';

import { INDUSTRY_GROUP_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/industryGroupOptions_deu';
import { INDUSTRY_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/industryOptions_deu';
import { INDUSTRY_GROUP_OPTIONS } from 'components/BusinessToolForm/constants/industryGroupOptions';
import { INDUSTRY_OPTIONS } from 'components/BusinessToolForm/constants/industryOptions';
import { INDUSTRY_GROUP_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/industryGroupOptions_ua';
import { INDUSTRY_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/industryOptions_ua';

export const getIndustryOptions = (value: IOptionType, language: string) => {
  if (!value?.value) {
    return null;
  }

  switch (language) {
    case 'de':
      return INDUSTRY_OPTIONS_DEU[value.value as keyof typeof INDUSTRY_OPTIONS_DEU];

    case 'uk':
      return INDUSTRY_OPTIONS_UA[value.value as keyof typeof INDUSTRY_OPTIONS_UA];

    default:
      return INDUSTRY_OPTIONS[value.value as keyof typeof INDUSTRY_OPTIONS];
  }
};

export const getIndustryGroupOptions = (value: IOptionType, language: string) => {
  if (!value?.value) {
    return null;
  }

  switch (language) {
    case 'de':
      return INDUSTRY_GROUP_OPTIONS_DEU[value.value as keyof typeof INDUSTRY_GROUP_OPTIONS_DEU];

    case 'uk':
      return INDUSTRY_GROUP_OPTIONS_UA[value.value as keyof typeof INDUSTRY_GROUP_OPTIONS_UA];

    default:
      return INDUSTRY_GROUP_OPTIONS[value.value as keyof typeof INDUSTRY_GROUP_OPTIONS];
  }
};
